import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { IReceiptData } from '../../ApiCalls';

export interface ISelectedYachtState {
  value: IReceiptData;
};

const initialState: ISelectedYachtState = {
  value: {} as IReceiptData,
};

export const receiptChangesSlice = createSlice({
  name: 'receiptChanges',
  initialState,
  reducers: {
    updateReceiptChanges: (state, action: PayloadAction<IReceiptData>) => {
      state.value = action.payload;
    },
  },
});

export const { updateReceiptChanges } = receiptChangesSlice.actions;
export const receiptChangesState = (state: RootState) => state.receiptChanges.value;

export default receiptChangesSlice.reducer;
